export default {
  state: {
    globalLoader: false
  },
  actions: {},
  mutations: {
    toggleGlobalLoader(state, payload) {
      state.globalLoader = payload;
    }
  },
  getters: {},
  namespaced: true
};
